(() => {
    if (window.HFWhatsAppOrders) return;
    window.HFWhatsAppOrders = true;
    const endpoint = 'https://dvpekmzgudwiwjbxwfdn.supabase.co/functions/v1/whatsapp-orders';
    let strings;
    let dialog, cart, requestId, saved, submitting = false, loading = false;
    let priceLoading = false;
    const root = () => window.Shopify?.routes?.root || '/';
    const showError = message => { const node = dialog.querySelector('[data-hf-error]'); node.textContent = message; node.hidden = !message; };
    const fetchCart = async () => {
      const response = await fetch(root() + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error(strings.unavailable);
      const result = await response.json();
      if (!result.items?.length) throw new Error(strings.empty);
      return result;
    };
    const payloadItems = value => value.items.map(item => ({ variantId: String(item.variant_id || item.id), handle: item.handle, quantity: item.quantity, properties: item.properties || {} }));
    function priceMessage(button, items) {
      const lines = items.map((item, index) => {
        const properties = item.properties || {};
        const parts = [item.product_title];
        const size = properties['Quantity / Size'] || properties.Size;
        if (size) parts.push(size);
        if (properties.Form) parts.push(properties.Form);
        if (item.variant_title && item.variant_title !== 'Default Title' && !parts.includes(item.variant_title)) parts.push(item.variant_title);
        parts.push(`${button.dataset.hfPriceQuantity}: ${item.quantity}`);
        return `${index + 1}. ${parts.join(' · ')}${item.url ? '\n' + new URL(item.url, window.location.origin).href : ''}`;
      });
      return [button.dataset.hfPriceIntro, '', ...lines, '', button.dataset.hfPriceOutro].join('\n');
    }
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-hf-whatsapp-price]');
      if (!button) return;
      const isProduct = button.hasAttribute('data-hf-price-product');
      if (!isProduct) event.preventDefault();
      if (priceLoading) { event.preventDefault(); return; }
      const errorNode = button.closest('.hf-whatsapp-cart-order-wrapper').querySelector('[data-hf-price-error]');
      errorNode.hidden = true;
      let popup;
      try {
        const whatsappUrl = new URL(button.href);
        if (whatsappUrl.protocol !== 'https:' || whatsappUrl.hostname !== 'wa.me') throw new Error(button.dataset.hfPriceUnavailable);
        let items;
        if (isProduct) {
          const form = button.closest('form');
          if (!form) throw new Error(button.dataset.hfPriceUnavailable);
          const grams = form.querySelector('[data-hf-grams-number]');
          if (grams && !grams.reportValidity()) { event.preventDefault(); return; }
          const data = new FormData(form);
          const variantId = String(data.get('id') || '');
          const variant = JSON.parse(button.dataset.hfPriceVariants).find(value => String(value.id) === variantId);
          const quantity = Number(data.get('quantity') || 1);
          if (!variant || !Number.isInteger(quantity) || quantity < 1) throw new Error(button.dataset.hfPriceUnavailable);
          const productUrl = new URL(button.dataset.hfPriceUrl);
          productUrl.searchParams.set('variant', variantId);
          items = [{ product_title: button.dataset.hfPriceTitle, variant_title: variant.title, quantity, url: productUrl.href,
            properties: { 'Quantity / Size': data.get('properties[Quantity / Size]') || data.get('properties[Size]'), Form: data.get('properties[Form]') } }];
        } else {
          priceLoading = true;
          button.setAttribute('aria-busy', 'true');
          try { popup = window.open('about:blank', '_blank'); if (popup) popup.opener = null; } catch {}
          const response = await fetch(root() + 'cart.js', { cache: 'no-store', signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error(button.dataset.hfPriceUnavailable);
          const latest = await response.json();
          if (!latest.items?.length) throw new Error(button.dataset.hfPriceEmpty);
          items = latest.items;
        }
        whatsappUrl.searchParams.set('text', priceMessage(button, items));
        if (popup) popup.location.replace(whatsappUrl.href);
        else if (isProduct) button.href = whatsappUrl.href;
        else window.location.assign(whatsappUrl.href);
      } catch (error) {
        event.preventDefault();
        if (popup) popup.close();
        errorNode.textContent = error.message === button.dataset.hfPriceEmpty ? button.dataset.hfPriceEmpty : button.dataset.hfPriceUnavailable;
        errorNode.hidden = false;
      } finally {
        priceLoading = false;
        button.removeAttribute('aria-busy');
      }
    }, true);
    function ensureDialog() {
      if (dialog) return;
      const template = document.querySelector('[data-hf-whatsapp-template]');
      strings = { loading: template.dataset.hfLoading, saving: template.dataset.hfSaving, empty: template.dataset.hfEmpty, unavailable: template.dataset.hfUnavailable, copied: template.dataset.hfCopied, continue: template.dataset.hfContinue };
      document.body.appendChild(template.content.cloneNode(true));
      dialog = document.querySelector('.hf-whatsapp-dialog');
      dialog.querySelector('[data-hf-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); }
      });
      dialog.querySelector('[data-hf-copy]').addEventListener('click', async event => {
        try { await navigator.clipboard.writeText(saved.message); event.target.textContent = strings.copied; } catch { showError(strings.unavailable); }
      });
      dialog.querySelector('[data-hf-request-form]').addEventListener('submit', async event => {
        event.preventDefault();
        if (submitting || loading) return;
        submitting = true;
        const button = dialog.querySelector('[data-hf-submit]');
        button.disabled = true; button.textContent = strings.saving; showError('');
        let popup;
        try { popup = window.open('about:blank', '_blank'); if (popup) popup.opener = null; } catch {}
        try {
          const latest = await fetchCart();
          if (JSON.stringify(payloadItems(latest)) !== JSON.stringify(payloadItems(cart))) { cart = latest; requestId = crypto.randomUUID(); }
          const data = new FormData(event.target);
          const customer = Object.fromEntries(['name', 'phone', 'city', 'address', 'notes'].map(key => [key, String(data.get(key) || '').trim()]));
          const response = await fetch(endpoint, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: AbortSignal.timeout(30000),
            body: JSON.stringify({ clientRequestId: requestId, customer, items: payloadItems(cart), website: data.get('website') }),
          });
          const result = await response.json();
          if (!response.ok || !result.success) { if (response.status === 409) requestId = crypto.randomUUID(); throw new Error(result.error || strings.unavailable); }
          const whatsappUrl = new URL(result.whatsappUrl);
          if (whatsappUrl.protocol !== 'https:' || whatsappUrl.hostname !== 'wa.me') throw new Error(strings.unavailable);
          saved = result;
          dialog.querySelector('[data-hf-reference]').textContent = result.reference;
          dialog.querySelector('[data-hf-open-whatsapp]').href = result.whatsappUrl;
          event.target.hidden = true; dialog.querySelector('[data-hf-success]').hidden = false;
          if (popup) popup.location.replace(result.whatsappUrl);
        } catch (error) { if (popup) popup.close(); showError(error.name === 'TimeoutError' ? strings.unavailable : (error.message || strings.unavailable)); }
        finally { submitting = false; button.disabled = false; button.textContent = strings.continue; }
      });
    }
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-hf-whatsapp-order]');
      if (!button || loading || submitting) return;
      if (button.hasAttribute('data-hf-whatsapp-product')) {
        event.preventDefault();
        const form = button.closest('form');
        if (!form) return;
        const invalid = Array.from(form.elements).find(field => field.name && field.willValidate && !field.checkValidity());
        if (invalid) { invalid.reportValidity(); return; }
        loading = true; button.disabled = true;
        try {
          const response = await fetch(root() + 'cart/add.js', {
            method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form), signal: AbortSignal.timeout(30000),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message);
          window.location.assign(root() + 'cart?whatsapp=1');
        } catch (error) {
          ensureDialog();
          dialog.querySelector('[data-hf-request-form]').hidden = true;
          dialog.querySelector('[data-hf-success]').hidden = true;
          if (!dialog.open) dialog.showModal();
          showError(error.name === 'TimeoutError' ? strings.unavailable : (error.message || strings.unavailable));
        } finally { loading = false; button.disabled = false; }
        return;
      }
      event.preventDefault(); ensureDialog();
      if (saved) {
        try {
          const latest = await fetchCart();
          if (JSON.stringify(payloadItems(latest)) === JSON.stringify(payloadItems(cart))) { if (!dialog.open) dialog.showModal(); return; }
          saved = null; requestId = crypto.randomUUID();
        } catch (error) { if (!dialog.open) dialog.showModal(); showError(error.message || strings.unavailable); return; }
      }
      dialog.querySelector('[data-hf-request-form]').hidden = false;
      dialog.querySelector('[data-hf-success]').hidden = true;
      if (!dialog.open) dialog.showModal(); showError(''); loading = true;
      const submit = dialog.querySelector('[data-hf-submit]'); submit.disabled = true;
      const summary = dialog.querySelector('[data-hf-summary]'); summary.textContent = strings.loading;
      try {
        cart = await fetchCart(); requestId = requestId || crypto.randomUUID();
        const list = document.createElement('ul');
        cart.items.forEach(item => {
          const line = document.createElement('li'); const properties = item.properties || {};
          const size = properties['Quantity / Size'] || properties.Size || item.variant_title;
          line.textContent = `${item.product_title}${size && size !== 'Default Title' ? ' · ' + size : ''}${properties.Form ? ' · ' + properties.Form : ''} × ${item.quantity}`;
          list.appendChild(line);
        });
        summary.replaceChildren(list); submit.disabled = false;
      } catch (error) { summary.textContent = ''; showError(error.message || strings.unavailable); }
      finally { loading = false; }
    }, true);
    const url = new URL(window.location.href);
    if (url.searchParams.get('whatsapp') === '1') {
      const button = document.querySelector('[data-hf-whatsapp-order]:not([data-hf-whatsapp-product])');
      if (button && !button.disabled) {
        url.searchParams.delete('whatsapp');
        window.history.replaceState(null, '', url);
        button.click();
      }
    }
  })();
